import React from 'react';
import cs from 'classnames';
import PropTypes from 'prop-types';

import './card.css';

const Card = ({className, color, titleHighlight, shadow, icon, materialIcon, title, heading, children}) => {

	const classes = cs(
		'card',
		className ? `${className}`: false,
		color ? `card--${color}`: false,
		{'card--title-highlight': titleHighlight},
		{'card--shadow' : shadow},
		{'card--has-icon': icon || materialIcon},
	)

	const Header = heading;

	return (
		<div className={classes}>
			{title && <Header className="card__title">{title}</Header>}
			<div className="card__content">{children}</div>
			{icon && <div className="card__icon"><img src={icon} alt="" /></div>}
			{materialIcon && 
				<div className="card__icon">
					<span className="material-icons card__material-icon">{materialIcon}</span>
				</div>
			}
		</div>
	);
};

Card.propTypes = {
	classname: PropTypes.string,
	color: PropTypes.oneOf([
		'primary', 
		'secondary',
		'tertiary',
		'error',
		'success',
	]),
	titleHighlight: PropTypes.bool,
	shadow: PropTypes.bool.isRequired,
	icon: PropTypes.string,
	materialIcon: PropTypes.string,
	title: PropTypes.string,
	heading: PropTypes.oneOf(['h1','h2','h3','h4','h5','h6',]),
}

Card.defaultProps = {
	shadow: true,
	heading: "h2",
}

export default Card;


// WEBPACK FOOTER //
// ./src/components/common/Card/index.js